import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DomainBidderErrors } from './types'

export const DOMAIN_BIDDER_ERROR_FRAGMENT: TypedDocumentNode<DomainBidderErrors> = gql`
  ${ERROR_FRAGMENT}

  fragment DomainBidderErrorFragment on DomainBidderErrors {
    domainBidderId

    adUnitBidders {
      adUnitBidderId
      errors {
        ...ErrorFragment
      }
    }
  }
`
